module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('em', [_vm._v("For my readers"), _c('br'), _vm._v("Who sent me emails and messages that made me smile"), _c('br'), _vm._v("Who told their friends about my books"), _c('br'), _vm._v("Who stayed with this series from start to finish"), _c('br'), _vm._v("Who knew me long before that,"), _c('br'), _vm._v("and who have encouraged me all these years"), _c('br'), _vm._v("I wrote this last one for all of you")]), _vm._v("."), _c('br'), _c('em', [_vm._v("—Elizabeth May")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23768659","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03dedication.vue
// module id = 60
// module chunks = 0